<div class="sondermind-design-system modal-container" fxLayout="column">

  <div sondermindMediaQueryAttribute class="content-area">
    <ng-template [cdkPortalOutlet]="modalPortal">
    </ng-template>
      <div class="modal-spinner" *ngIf="saving">
      <div class="modal-spinner-container">
        <mat-spinner
          color="primary"
          diameter="88"
          strokeWidth="6"
          [attr.aria-label]="data.spinnerText"
        ></mat-spinner>
        <span class="modal-spinner-text">{{ data.spinnerText }}</span>
      </div>
    </div>
  </div>

  <mat-dialog-actions
    *ngIf="data.actions.length > 0"
    fxLayout="row"
    fxLayoutAlign.gt-xs="end center"
    fxLayoutAlign.lt-sm="center center"
  >
    <div sondermind-button-row>
        <ng-container *ngFor="let button of data.actions" [ngSwitch]="button.style">
            <iris-button
              *ngSwitchCase="'primary'"
              data-test="save-button"
              [disabled]="disableButtons || button.disabled"
              (click)="button.onClick.next($event)">{{button.text}}
            </iris-button>
            <iris-button
              *ngSwitchCase="'secondary'"
              [type]="irisButtonTypes.SECONDARY"
              [disabled]="disableButtons || button.disabled"
              (click)="button.onClick.next($event)"
            >
              {{button.text}}
            </iris-button>
            <iris-button
              *ngSwitchCase="'tertiary'"
              [type]="irisButtonTypes.TERTIARY"
              [disabled]="disableButtons || button.disabled"
              (click)="button.onClick.next($event)"
            >
              {{button.text}}
            </iris-button>
            <iris-button
              *ngSwitchCase="'default'"
              [type]="irisButtonTypes.SECONDARY"
              [disabled]="disableButtons || button.disabled"
              (click)="button.onClick.next($event)"
            >
              {{button.text}}
            </iris-button>
        </ng-container>
    </div>
  </mat-dialog-actions>
</div>
